export default __webpack_public_path__ + "static/media/emptyMeetingsView.3bdd333b.svg";